<template>
  <div class="articles-list-container">
    <div class="articles-list" v-if="articles.length">
      <v-col cols="12" sm="6" v-for="a in articles" :key="a.id">
        <PdfItem
          :articleId="a.id"
          :articleTitle="a.title"
          :searchTexts="searchTexts"
          :originalId="a.original"
          :isOpenAccess="a.open"
        />
      </v-col>
    </div>
    <div v-else-if="isSearch" class="text-center">
      {{ $t('search.noArticles') }}
    </div>
    <div v-else class="text-center">
      {{ $t('common.noArticles') }}
    </div>
  </div>
</template>

<script>
import PdfItem from '@/components/PdfItem'

export default {
  props: {
    articles: Array,
    searchTexts: Array
  },
  data() {
    return { isSearch: false }
  },
  created() {
    if (this.$route.meta.isSearch) {
      this.isSearch = true
    }
  },
  components: {
    PdfItem
  }
}
</script>

<style lang="scss">
.articles-list-container {
  padding: 0 10px;

  .articles-list {
    .pdf-article {
      margin: auto;
    }
  }
}
</style>
